import {ReactNode} from 'react';

import {createEvent, restore} from 'effector';

export const setHeaderTitle = createEvent<{title: string; controls?: ReactNode}>();
export const headerTitle$ = restore(setHeaderTitle, {title: ''});
